import { render, staticRenderFns } from "./ImprimirPage.vue?vue&type=template&id=51a944f2"
import script from "./ImprimirPage.js?vue&type=script&lang=js&external"
export * from "./ImprimirPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports